import { render, staticRenderFns } from "./ScrunchieMaterialPopup.vue?vue&type=template&id=2b05e340&scoped=true"
import script from "./ScrunchieMaterialPopup.vue?vue&type=script&lang=js"
export * from "./ScrunchieMaterialPopup.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./ScrunchieMaterialPopup.vue?vue&type=style&index=1&id=2b05e340&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05e340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b05e340')) {
      api.createRecord('2b05e340', component.options)
    } else {
      api.reload('2b05e340', component.options)
    }
    module.hot.accept("./ScrunchieMaterialPopup.vue?vue&type=template&id=2b05e340&scoped=true", function () {
      api.rerender('2b05e340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/scrunchieArrangement/components/ScrunchieMaterialPopup.vue"
export default component.exports